import BaseStore from "./BaseStore";

export default class CookieConsentStore extends BaseStore {
  static KEY = "cookie-consent";

  static set(value, ctx = null) {
    super.set(value, ctx, value ? 60 * 60 * 24 * 365 * 10 : null);
  }
}
